import { connect } from "react-redux";
import { InternalTools } from "./InternalTools.page";
import { redirectToRoute } from "redux/utils"; // This is `src/redux/utils`

export default connect(null, { redirectToRoute })(InternalTools);
